import script from "./TripTmsIssueCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TripTmsIssueCard.vue?vue&type=script&setup=true&lang=js"

import "./TripTmsIssueCard.vue?vue&type=style&index=0&id=632ec2ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-632ec2ee"]])

export default __exports__